import React, { useEffect, useState } from "react";

// import JS files
import PTabZero from "./PTabZero";
import PTabOne from "./PTabOne";
import PTabTwo from "./PTabTwo";
import PBasketBox from "./PBasketBox";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useProducerBasket } from "../../../../context/ProducerBasketContext";
import { useLocation } from "react-router-dom";
import PTabThree from "./PTabThree";

const ProducerCreateOrderNew = (props) => {
  const { selectedUserContext } = useProducerBasket();

  const location = useLocation();

  // username selected user - combo value
  const [selectedProducer, setSelectedProducer] = useState(
    location.state !== null ? location.state.userInfo.username : undefined
  );

  const [selectedUser, setSelectedUser] = useState(
    location.state !== null
      ? location.state.userInfo
      : selectedUserContext !== undefined
      ? selectedUserContext
      : undefined
  );

  const [activeTab, setActiveTab] = useState("0");
  const [needRefetch, setNeedRefetch] = useState(false);
  useEffect(() => {
    setSelectedUser(selectedUserContext);
  }, [selectedUserContext]);

  useEffect(() => {
    if (location.state !== null) {
      setSelectedUser(location.state.userInfo);
      setSelectedProducer(location.state.userInfo.username);
    }
  }, [location.state]);

  return (
    <>
      <PanelTemplate sidebarActiveLink="p-create-order">
        <div className="mt-12 flex items-center">
          <span
            className={activeTab == "0" ? "active-tab" : "not-active-tab"}
            onClick={() => setActiveTab("0")}
          >
            انتخاب تولیدکننده
          </span>
          <span
            className={activeTab == "1" ? "active-tab" : "not-active-tab"}
            onClick={() => setActiveTab("1")}
          >
            نمایش تمام محصولات
          </span>
          <span
            className={activeTab == "2" ? "active-tab" : "not-active-tab"}
            onClick={() => setActiveTab("2")}
          >
            افزودن بر اساس تعداد
          </span>
        </div>
        <div
          style={{ backgroundColor: "#fefcfb" }}
          className="border rounded-b-md rounded-tl-md px-2 py-6 mb-4"
        >
          {activeTab == "0" ? (
            <PTabZero
              selectedCustomer={selectedProducer}
              setSelectedCustomer={setSelectedProducer}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
            />
          ) : activeTab == "1" ? (
            <PTabOne selectedUser={selectedUser} />
          ) : (
            <PTabThree selectedUser={selectedUser} needRefetch={needRefetch} />
          )}
        </div>
        <div className="panel-main-header mt-10">
          <span>ثبت سفارش محصولات</span>
        </div>
        <PBasketBox
          AdminCreateOrderForUser
          selectedCustomer={selectedProducer}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          setSelectedCustomer={setSelectedProducer}
          isAdmin
          needRefetchProviderTabThreeFornums
          setActiveTab={setActiveTab}
          ProducerCreateOrder
        />
      </PanelTemplate>
    </>
  );
};

export default ProducerCreateOrderNew;
